import { render } from "./NavItem.vue?vue&type=template&id=1651093f&scoped=true"
import script from "./NavItem.vue?vue&type=script&lang=js"
export * from "./NavItem.vue?vue&type=script&lang=js"

import "./NavItem.vue?vue&type=style&index=0&id=1651093f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1651093f"

export default script